
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class GetJsonService {
  private _http = inject(HttpClient);

  get(_url: string): Observable<any[]> {
    return this._http.get(_url).pipe(
      map((response) => <any[]>response),
      tap(data => console.log('All: ' + JSON.stringify(data))),);
  }
}